import Bugsnag from "@bugsnag/js"
import isFunction from "lodash/isFunction"

function bugsnagIsReady() {
    return !!Bugsnag._client && import.meta.env.VITE_ENABLE_BUGSNAG === "true"
}

export function notify(error) {
    if (bugsnagIsReady()) {
        if (!(error instanceof Error)) error = new Error(error)

        let onError = () => {}
        if (isFunction(error.getMetadata)) {
            onError = event =>
                event.addMetadata("metadata", error.getMetadata())
        }

        Bugsnag.notify(error, onError)
    } else {
        console.error(error)
    }
}

export function leaveBreadcrumb(...args) {
    if (bugsnagIsReady()) {
        Bugsnag.leaveBreadcrumb(args.toString())
    } else {
        console.log(...args)
    }
}
